import { isEmpty, isNil } from 'lodash-es';
export const keysOf = (x) => Object.keys(x);
export const numEnumValuesOf = (x) => Object.values(x)
    .map((x) => parseInt(x, 10))
    .filter((x) => !isNaN(x));
export function isKeyOf(key, objectToTest) {
    return keysOf(objectToTest).includes(key);
}
/**
 * Transforms an array, into a string of value separated by a comma
 * @param array to parse as a string
 * @returns a string or undefined
 * @example [1,2,3] will become "1,2,3"
 */
export function queryParamArrayAsString(array) {
    return !isNil(array) && !isEmpty(array) ? array.join(',') : undefined;
}
/**
 * Create the search params "depth" for plot creation and plot device edition
 * @param deviceId
 * @param depthValue
 * @param horizonId
 * @returns deviceId_depthValue_horizonId
 */
export function createQueryParamDepthTemplate(deviceId, depthValue, horizonId) {
    return `${deviceId}_${depthValue}_${horizonId}`;
}
